// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ReportsRouteImport } from './routes/reports'
import { Route as PublishRouteImport } from './routes/publish'
import { Route as PricesRouteImport } from './routes/prices'
import { Route as NotificationsRouteImport } from './routes/notifications'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LawRouteImport } from './routes/law'
import { Route as JobsRouteImport } from './routes/jobs'
import { Route as DiscountsRouteImport } from './routes/discounts'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as SplatRouteImport } from './routes/$'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CheckoutIndexRouteImport } from './routes/checkout.index'
import { Route as StatusTrackingIdRouteImport } from './routes/status.$trackingId'
import { Route as CheckoutReturnRouteImport } from './routes/checkout.return'
import { Route as AdminReportsRouteImport } from './routes/admin.reports'
import { Route as AdminDashboardRouteImport } from './routes/admin.dashboard'
import { Route as AdminAuditRouteImport } from './routes/admin.audit'
import { Route as ReportsIdRouteImport } from './routes/reports.$id'
import { Route as AdminUsersIndexRouteImport } from './routes/admin.users.index'
import { Route as AdminNomenclatureIndexRouteImport } from './routes/admin.nomenclature.index'
import { Route as AdminUsersNewRouteImport } from './routes/admin.users.new'
import { Route as AdminUsersIdRouteImport } from './routes/admin.users.$id'
import { Route as AdminNomenclatureNewRouteImport } from './routes/admin.nomenclature.new'
import { Route as AdminNomenclatureTypeCodeRouteImport } from './routes/admin.nomenclature.$typeCode'

const ReportsRoute = ReportsRouteImport.update({
            id: '/reports',path: '/reports',getParentRoute: () => rootRouteImport
          })
const PublishRoute = PublishRouteImport.update({
            id: '/publish',path: '/publish',getParentRoute: () => rootRouteImport
          })
const PricesRoute = PricesRouteImport.update({
            id: '/prices',path: '/prices',getParentRoute: () => rootRouteImport
          })
const NotificationsRoute = NotificationsRouteImport.update({
            id: '/notifications',path: '/notifications',getParentRoute: () => rootRouteImport
          })
const LogoutRoute = LogoutRouteImport.update({
            id: '/logout',path: '/logout',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const LawRoute = LawRouteImport.update({
            id: '/law',path: '/law',getParentRoute: () => rootRouteImport
          })
const JobsRoute = JobsRouteImport.update({
            id: '/jobs',path: '/jobs',getParentRoute: () => rootRouteImport
          })
const DiscountsRoute = DiscountsRouteImport.update({
            id: '/discounts',path: '/discounts',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const SplatRoute = SplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const CheckoutIndexRoute = CheckoutIndexRouteImport.update({
            id: '/checkout/',path: '/checkout/',getParentRoute: () => rootRouteImport
          })
const StatusTrackingIdRoute = StatusTrackingIdRouteImport.update({
            id: '/status/$trackingId',path: '/status/$trackingId',getParentRoute: () => rootRouteImport
          })
const CheckoutReturnRoute = CheckoutReturnRouteImport.update({
            id: '/checkout/return',path: '/checkout/return',getParentRoute: () => rootRouteImport
          })
const AdminReportsRoute = AdminReportsRouteImport.update({
            id: '/admin/reports',path: '/admin/reports',getParentRoute: () => rootRouteImport
          })
const AdminDashboardRoute = AdminDashboardRouteImport.update({
            id: '/admin/dashboard',path: '/admin/dashboard',getParentRoute: () => rootRouteImport
          })
const AdminAuditRoute = AdminAuditRouteImport.update({
            id: '/admin/audit',path: '/admin/audit',getParentRoute: () => rootRouteImport
          })
const ReportsIdRoute = ReportsIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => ReportsRoute
          })
const AdminUsersIndexRoute = AdminUsersIndexRouteImport.update({
            id: '/admin/users/',path: '/admin/users/',getParentRoute: () => rootRouteImport
          })
const AdminNomenclatureIndexRoute = AdminNomenclatureIndexRouteImport.update({
            id: '/admin/nomenclature/',path: '/admin/nomenclature/',getParentRoute: () => rootRouteImport
          })
const AdminUsersNewRoute = AdminUsersNewRouteImport.update({
            id: '/admin/users/new',path: '/admin/users/new',getParentRoute: () => rootRouteImport
          })
const AdminUsersIdRoute = AdminUsersIdRouteImport.update({
            id: '/admin/users/$id',path: '/admin/users/$id',getParentRoute: () => rootRouteImport
          })
const AdminNomenclatureNewRoute = AdminNomenclatureNewRouteImport.update({
            id: '/admin/nomenclature/new',path: '/admin/nomenclature/new',getParentRoute: () => rootRouteImport
          })
const AdminNomenclatureTypeCodeRoute = AdminNomenclatureTypeCodeRouteImport.update({
            id: '/admin/nomenclature/$typeCode',path: '/admin/nomenclature/$typeCode',getParentRoute: () => rootRouteImport
          })





const ReportsRouteChildren = {
  ReportsIdRoute: ReportsIdRoute
}

const ReportsRouteWithChildren = ReportsRoute._addFileChildren(ReportsRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,SplatRoute: SplatRoute,ContactRoute: ContactRoute,DiscountsRoute: DiscountsRoute,JobsRoute: JobsRoute,LawRoute: LawRoute,LoginRoute: LoginRoute,LogoutRoute: LogoutRoute,NotificationsRoute: NotificationsRoute,PricesRoute: PricesRoute,PublishRoute: PublishRoute,ReportsRoute: ReportsRouteWithChildren,AdminAuditRoute: AdminAuditRoute,AdminDashboardRoute: AdminDashboardRoute,AdminReportsRoute: AdminReportsRoute,CheckoutReturnRoute: CheckoutReturnRoute,StatusTrackingIdRoute: StatusTrackingIdRoute,CheckoutIndexRoute: CheckoutIndexRoute,AdminNomenclatureTypeCodeRoute: AdminNomenclatureTypeCodeRoute,AdminNomenclatureNewRoute: AdminNomenclatureNewRoute,AdminUsersIdRoute: AdminUsersIdRoute,AdminUsersNewRoute: AdminUsersNewRoute,AdminNomenclatureIndexRoute: AdminNomenclatureIndexRoute,AdminUsersIndexRoute: AdminUsersIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)